import { useQuery } from '@tanstack/react-query';

import { meAccessQueryOptions } from '../../../access';
import { usePlantLabel } from '../../close-the-loop';
import type { PlantScope } from '../domain/hearLines';

export const usePlantScope = (): PlantScope => {
  const { data: me } = useQuery(meAccessQueryOptions());
  const plantIds = me?.plantIds ?? [];
  const first = usePlantLabel(plantIds[0] ?? null);
  return { first, others: Math.max(0, plantIds.length - 1) };
};
